module.exports = __webpack_public_path__ + "img/superprivacy-icon-inactive.37dc66e5.svg";